import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgMagnifyingGlass = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 12"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.765 10.235 8.418 7.89a4.13 4.13 0 1 0-.53.53l2.346 2.347a.373.373 0 0 0 .53 0 .375.375 0 0 0 0-.53m-8.89-4.984a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMagnifyingGlass);
export default ForwardRef;
